module.exports = __webpack_public_path__ + "04_short_black.a3efa8c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/aoyama/daughter/layer5/04_short_black.png
// module id = OV+P
// module chunks = 0